import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/components/auth/RequireAuth";
import { AdminOnly } from "@/components/auth/AdminOnly";
import Login from "@/routes/Login";
import Signup from "@/routes/Signup";
import ForgotPassword from "@/routes/ForgotPassword";
import ResetPassword from "@/routes/ResetPassword";
import VerifyEmail from "@/routes/VerifyEmail";
import Terms from "@/routes/Terms";
import Overview from "@/routes/Overview";
import Cycles from "@/routes/Cycles";
import Pending from "@/routes/Pending";
import Trades from "@/routes/Trades";
import Markets from "@/routes/Markets";
import Performance from "@/routes/Performance";
import Portfolio from "@/routes/Portfolio";
import Holdings from "@/routes/Holdings";
import Intelligence from "@/routes/Intelligence";
import Settings from "@/routes/Settings";
import Logs from "@/routes/Logs";
import AdminUsers from "@/routes/AdminUsers";
import WalletReconcile from "@/routes/WalletReconcile";
import Audit from "@/routes/Audit";
import News from "@/routes/News";
import AdminUserDetail from "@/routes/AdminUserDetail";
import Dca from "@/routes/Dca";
import Strategy from "@/routes/Strategy";
import PrePumpTrades from "@/routes/PrePumpTrades";
import AlphaBscOverview from "@/routes/alpha_bsc/AlphaBscOverview";
import AlphaBscWatchlist from "@/routes/alpha_bsc/AlphaBscWatchlist";
import AlphaBscManual from "@/routes/alpha_bsc/AlphaBscManual";
import AlphaBscAuto from "@/routes/alpha_bsc/AlphaBscAuto";
import AlphaBscHistory from "@/routes/alpha_bsc/AlphaBscHistory";
import AlphaBscWallet from "@/routes/alpha_bsc/AlphaBscWallet";
import GridOverview from "@/routes/grid/GridOverview";
import GridBacktest from "@/routes/grid/GridBacktest";
import GridSettings from "@/routes/grid/GridSettings";
import Allocation from "@/routes/Allocation";
import Research from "@/routes/Research";
import InventorySwing from "@/routes/InventorySwing";
import Legacy from "@/routes/Legacy";
import Harvest from "@/routes/Harvest";

export const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  { path: "/signup", element: <Signup /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/verify-email", element: <VerifyEmail /> },
  { path: "/terms", element: <Terms /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <AppShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Overview /> },
      { path: "pending", element: <Pending /> },
      { path: "trades", element: <Trades /> },
      { path: "settings", element: <Settings /> },
      // Admin-only
      { path: "cycles", element: <Cycles /> },
      { path: "markets", element: <AdminOnly><Markets /></AdminOnly> },
      { path: "performance", element: <Performance /> },
      { path: "portfolio", element: <AdminOnly><Portfolio /></AdminOnly> },
      { path: "holdings", element: <AdminOnly><Holdings /></AdminOnly> },
      { path: "intelligence", element: <AdminOnly><Intelligence /></AdminOnly> },
      { path: "logs", element: <AdminOnly><Logs /></AdminOnly> },
      { path: "admin/users", element: <AdminOnly><AdminUsers /></AdminOnly> },
      { path: "admin/users/:uid", element: <AdminOnly><AdminUserDetail /></AdminOnly> },
      { path: "admin/wallet", element: <AdminOnly><WalletReconcile /></AdminOnly> },
      { path: "admin/audit", element: <AdminOnly><Audit /></AdminOnly> },
      { path: "admin/news", element: <AdminOnly><News /></AdminOnly> },
      { path: "admin/dca", element: <AdminOnly><Dca /></AdminOnly> },
      { path: "admin/strategy", element: <AdminOnly><Strategy /></AdminOnly> },
      { path: "admin/pre-pump", element: <AdminOnly><PrePumpTrades /></AdminOnly> },
      // ---- Alpha BSC (on-chain trading via PancakeSwap + Uniswap V3 BSC) ----
      { path: "alpha-bsc", element: <AdminOnly><AlphaBscOverview /></AdminOnly> },
      { path: "alpha-bsc/watchlist", element: <AdminOnly><AlphaBscWatchlist /></AdminOnly> },
      { path: "alpha-bsc/manual", element: <AdminOnly><AlphaBscManual /></AdminOnly> },
      { path: "alpha-bsc/auto", element: <AdminOnly><AlphaBscAuto /></AdminOnly> },
      { path: "alpha-bsc/history", element: <AdminOnly><AlphaBscHistory /></AdminOnly> },
      { path: "alpha-bsc/wallet", element: <AdminOnly><AlphaBscWallet /></AdminOnly> },
      // ---- BTC Grid Trader (range-bound grid bot, ATR-adaptive, Gemini-gated) ----
      { path: "research", element: <AdminOnly><Research /></AdminOnly> },
      { path: "allocation", element: <AdminOnly><Allocation /></AdminOnly> },
      { path: "grid", element: <AdminOnly><GridOverview /></AdminOnly> },
      { path: "grid/backtest", element: <AdminOnly><GridBacktest /></AdminOnly> },
      { path: "grid/settings", element: <AdminOnly><GridSettings /></AdminOnly> },
      // ---- Inventory Swing (extract chop revenue from held inventory) ----
      { path: "inventory-swing", element: <AdminOnly><InventorySwing /></AdminOnly> },
      { path: "legacy", element: <AdminOnly><Legacy /></AdminOnly> },
      { path: "harvest", element: <Harvest /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
